import React, { createContext, useContext, useState } from "react";

import {
  Building,
  DeviceType,
  EnergyGroups,
  EnergyStatus,
  WifiQuality,
  hasFotovoltaico,
} from "api/onboardingTypes";

export type CityResponse = Array<Record<"city" | "sigla", string>>;

export interface GreenEnergyContextProps {
  energyGroup: EnergyGroups;
  setEnergyGroup: React.Dispatch<React.SetStateAction<EnergyGroups>>;
  city: CityResponse[0];
  setCity: React.Dispatch<React.SetStateAction<CityResponse[0]>>;
  offerId: string;
  setOfferId: React.Dispatch<React.SetStateAction<string>>;
  building: Partial<Building>;
  setBuilding: React.Dispatch<React.SetStateAction<Partial<Building>>>;
  monthlyCost: string;
  setMonthlyCost: React.Dispatch<React.SetStateAction<string>>;
  devices: Partial<Record<DeviceType["id"], number>>;
  setDevices: React.Dispatch<
    React.SetStateAction<Partial<Record<DeviceType["id"], number>>>
  >;
  wifiStatus: Partial<WifiQuality>;
  setWifiStatus: React.Dispatch<React.SetStateAction<Partial<WifiQuality>>>;
  hasFotovoltaico: hasFotovoltaico;
  sethasfotovoltaico: React.Dispatch<React.SetStateAction<hasFotovoltaico>>;
  amperage: string;
  setAmperage: React.Dispatch<React.SetStateAction<string>>;
  energyContractStatus: EnergyStatus;
  setEnergyContractStatus: React.Dispatch<React.SetStateAction<EnergyStatus>>;
  discount: string;
  setDiscount: React.Dispatch<React.SetStateAction<string>>;
}

export const GreenEnergyContext = createContext<GreenEnergyContextProps>(null!);

export const GreenEnergyProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [energyGroup, setEnergyGroup] = useState<EnergyGroups>(null!);
  const [city, setCity] = useState<CityResponse[0]>(null!);
  const [offerId, setOfferId] = useState<string>("");
  const [building, setBuilding] = useState<Partial<Building>>({});
  const [monthlyCost, setMonthlyCost] = useState<string>("");
  const [devices, setDevices] = useState<
    Partial<Record<DeviceType["id"], number>>
  >(null!);
  const [wifiStatus, setWifiStatus] = useState<WifiQuality>(null!);
  const [amperage, setAmperage] = useState<string>("");
  const [energyContractStatus, setEnergyContractStatus] =
    useState<EnergyStatus>(null!);
  const [discount, setDiscount] = useState<string>("0");
  const [hasFotovoltaico, sethasfotovoltaico] = useState<"Sim" | "Não">("Não");

  return (
    <GreenEnergyContext.Provider
      value={{
        energyGroup,
        setEnergyGroup,
        city,
        setCity,
        offerId,
        setOfferId,
        building,
        setBuilding,
        monthlyCost,
        setMonthlyCost,
        devices,
        setDevices,
        wifiStatus,
        setWifiStatus,
        amperage,
        setAmperage,
        hasFotovoltaico,
        sethasfotovoltaico,
        energyContractStatus,
        setEnergyContractStatus,
        discount,
        setDiscount,
      }}
    >
      {children}
    </GreenEnergyContext.Provider>
  );
};

export const useGreenEnergyContext = () => {
  const contextInfo = useContext(GreenEnergyContext);
  return {
    ...contextInfo,
  };
};
